import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["swiper"]

  declare swiperTarget: HTMLElement

  private swiperInitialized = false
  private menuScaleReady = false

  connect() {
    this.setupEventListeners()
    this.checkIfBothReady()
  }

  private setupEventListeners() {
    // Swiper初期化完了イベントをリッスン
    this.swiperTarget.addEventListener('preview-viewer:init-complete', () => {
      this.swiperInitialized = true
      this.checkIfBothReady()
    })

    // menu-scale準備完了イベントをリッスン
    // menu-scaleコントローラーは親要素にあるため、bubbleするイベントをキャッチ
    this.element.addEventListener('menu-scale:ready', () => {
      this.menuScaleReady = true
      this.checkIfBothReady()
    })
  }

  private checkIfBothReady() {
    if (this.swiperInitialized && this.menuScaleReady) {
      this.hideLoader()
    }
  }

  private hideLoader() {
    const loader = this.element.querySelector('.c-preview-block__loader') as HTMLElement | null
    if (loader) {
      loader.style.opacity = '0'
      loader.style.pointerEvents = 'none'
      // トランジション後に完全に非表示にする
      setTimeout(() => {
        loader.style.display = 'none'
      }, 300)
    }

    // Swiperを表示
    const swiper = this.swiperTarget as HTMLElement
    if (swiper) {
      swiper.style.opacity = '1'
    }
  }
}
